import { useEffect } from 'react';
import { ShieldCheckmark24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useAdminScreenStyles } from './AdminScreen.styles';
import { telemetry } from '@/services/telemetry';
import { TELEMETRY_COMPONENT } from '@/constants';

export const AdminScreen = () => {
  const styles = useAdminScreenStyles();
  const { t } = useTranslation();

  useEffect(() => {
    telemetry.trackPageView(TELEMETRY_COMPONENT, 'AdminScreen');
  }, []);

  return (
    <div className={styles.root}>
      <ShieldCheckmark24Regular className={styles.icon} />
      <h1 className={styles.title}>{t('screens.adminTitle')}</h1>
      <p className={styles.description}>{t('screens.comingSoonDescription')}</p>
    </div>
  );
};

AdminScreen.displayName = 'AdminScreen';
